import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7999a5f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = {
  key: 1,
  class: "statistics__content"
}
const _hoisted_3 = { class: "statistics__container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "statistics__title" }, [
  /*#__PURE__*/_createTextVNode("Статистика по"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("участникам клуба")
], -1))
const _hoisted_5 = { class: "statistics__block statistics_flex statistics_margin-bottom statistics_w100" }
const _hoisted_6 = { class: "statistics__case" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CountMembers = _resolveComponent("CountMembers")!
  const _component_Sex = _resolveComponent("Sex")!
  const _component_AnalyticsVertical = _resolveComponent("AnalyticsVertical")!
  const _component_Industry = _resolveComponent("Industry")!
  const _component_Geolocation = _resolveComponent("Geolocation")!
  const _component_Aggregate = _resolveComponent("Aggregate")!
  const _component_Stages = _resolveComponent("Stages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(), _createElementBlock("div", {
              class: "statistics_flex statistics_wrap",
              key: _ctx.loading
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CountMembers, {
                    class: "statistics_margin-bottom",
                    count: _ctx.countMembers
                  }, null, 8, ["count"]),
                  _createVNode(_component_Sex, {
                    wooman: _ctx.sex.wooman,
                    man: _ctx.sex.man
                  }, null, 8, ["wooman", "man"])
                ]),
                _createVNode(_component_AnalyticsVertical, { array: _ctx.age }, null, 8, ["array"])
              ]),
              _createVNode(_component_Industry, {
                array: _ctx.organisations,
                class: "statistics_margin-bottom statistics_w100"
              }, null, 8, ["array"]),
              _createVNode(_component_Geolocation, {
                class: "statistics_margin-bottom statistics_w100",
                array: _ctx.geolocation
              }, null, 8, ["array"]),
              _createVNode(_component_Aggregate, {
                class: "statistics_margin-bottom statistics_w100",
                title: 'Совокупная среднемесячная чистая прибыль всех бизнесов',
                footer: 'CРЕДНЯЯ ПРИБЫЛЬ В МЕСЯЦ:',
                footerEnd: '₽',
                array: _ctx.income.array,
                footerValue: _ctx.income.value
              }, null, 8, ["array", "footerValue"]),
              _createVNode(_component_Aggregate, {
                class: "statistics_margin-bottom statistics_w100",
                title: 'Совокупный среднемесячный оборот всех бизнесов',
                footer: 'CРЕДНИЙ ОБОРОТ В МЕСЯЦ:',
                footerEnd: '₽',
                array: _ctx.turnover.array,
                footerValue: _ctx.turnover.value
              }, null, 8, ["array", "footerValue"]),
              _createVNode(_component_Aggregate, {
                class: "statistics_margin-bottom statistics_w100",
                title: 'СОВОКУПНЫЙ ШТАТ ВСЕХ БИЗНЕСОВ',
                footer: 'cредний штат:',
                footerEnd: 'ЧЕЛОВЕК',
                array: _ctx.stuffCount.array,
                footerValue: _ctx.stuffCount.value
              }, null, 8, ["array", "footerValue"]),
              _createVNode(_component_Aggregate, {
                class: "statistics_margin-bottom statistics_w100",
                title: 'ЛЕТ В БИЗНЕСЕ',
                array: _ctx.yearsInBusiness
              }, null, 8, ["array"]),
              _createVNode(_component_Stages, {
                class: "statistics_w100",
                array: _ctx.stages
              }, null, 8, ["array"])
            ]))
          ])
        ]))
  ]))
}